import { render, staticRenderFns } from "./ckeditor.vue?vue&type=template&id=cf9d05a4"
import script from "./ckeditor.vue?vue&type=script&lang=js"
export * from "./ckeditor.vue?vue&type=script&lang=js"
import style0 from "./ckeditor.vue?vue&type=style&index=0&id=cf9d05a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports